export default __webpack_public_path__ + "static/media/mobile-auth-background.c574f9ac.webp";